import styles from './video.module.sass'

function VideoAsset(props) {
	let fields = props.fields

	return <div className={styles.video}>
		<h1>{fields.title}</h1>
		<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}}></div>
		<iframe width="100%" height="100%" src={fields.video_url} title={fields.title} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
	</div>
}

export default VideoAsset